import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { CardPlastic } from "../components/CardPlastic";

export const PlasticScreen: React.FC = () => {
	return (
		<>
			<Row
				flexible
				mainAxisAlignment="center"
				crossAxisAlignment="center"
				className="relative py-14 max-md:px-5 md:py-36 bg-cover bg-[url('https://www.europarl.europa.eu/resources/library/images/20181008PHT15277/20181008PHT15277_original.jpg')] bg-top"
				responsiveCol
			>
				<div className="absolute bg-black/40 top-0 left-0 w-full h-full" />
				<Column
					className="w-full z-[1]"
					data-sal="zoom-out"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="extraBig"
						className="font-title max-md:text-4xl text-center !leading-none text-white"
					>
						Contaminación <br /> Plástica
					</TextComponent>
				</Column>
			</Row>
			<Row
				className="max-md:px-5 gap-5 md:gap-10 sm:w-[40rem] md:w-[50rem] xl:w-[60rem] self-center py-10"
				responsiveCol
			>
				<img
					src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80"
					alt="Contaminación plástica en el océano"
					className="w-full md:w-2/5 rounded-lg object-cover max-md:order-last"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<TextComponent
					variant="h5"
					className="text-gray-700 text-base md:w-3/5 space-y-4"
					data-sal="slide-left"
					data-sal-duration="1000"
				>
					Se estima que <strong className="text-yellow-600 font-bold">millones de toneladas de plástico</strong> ingresan cada año a las aguas del{" "}
					<span className="text-cyan-600 font-bold">océano Pacífico</span> frente a la costa tacneña.
					<br /> <br />
					Esto equivale a que un <strong className="text-red-600 font-semibold">camión de basura arroje una carga completa de plástico cada minuto</strong>, durante todo el día, todos los
					días del año.
					<br /> <br />
					La cantidad de <span className="font-semibold text-red-600">contaminación plástica</span> en estas aguas se <strong>duplica aproximadamente cada seis años</strong>.
					<br /> <br />
					Si esta tendencia continúa, para el <strong className="text-yellow-600 font-bold">2050 el peso total de la contaminación plástica</strong> podría{" "}
					<strong className="text-red-600 font-bold">superar al peso total de todos los peces</strong> en la zona.
				</TextComponent>
			</Row>
			<Column
				crossAxisAlignment="center"
				className="bg-gradient-to-r from-cyan-600 to-blue-600 w-full py-10 px-5 gap-5 mt-5 md:mt-10"
			>
				<TextComponent
					variant="big"
					className="font-title text-center !leading-none text-white"
					data-sal="slide-right"
					data-sal-duration="1000"
				>
					Fuentes comunes de <br /> contaminación plástica
				</TextComponent>
				<Row
					className="gap-5 grid grid-cols-1 md:grid-cols-3 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
					responsiveCol
				>
					<CardPlastic
						title="Tecnopor"
						description={
							<TextComponent
								variant="h5"
								className="text-center"
							>
								Los productos de <span className="font-semibold text-yellow-600">espuma de poliestireno expandido</span>, incluidos los{" "}
								<span className="font-semibold text-yellow-600">utensilios de comida de poliestireno</span>, se encuentran esparcidos por toda la{" "}
								<span className="text-cyan-600 font-bold">costa tacneña</span>. Al romperse fácilmente en pequeños pedazos, los{" "}
								<span className="font-semibold text-red-600">peces y animales marinos se envenenan</span> por su ingesta.
							</TextComponent>
						}
						imageSrc="https://www.mauicounty.gov/ImageRepository/Document?documentID=114221"
						imageAlt="ave rompiendo tecnopor"
					/>
					<CardPlastic
						title="Bolsas"
						description={
							<TextComponent
								variant="h5"
								className="text-center"
							>
								Las <span className="font-semibold text-yellow-600">bolsas de un solo uso</span> se encuentran regadas por toda la costa, que luego terminan en las profundidades del
								mar, afectando a los <span className="font-semibold text-red-600">animales marinos</span>. En Tacna, forman parte de la vida cotidiana más del{" "}
								<span className="font-bold text-yellow-600">54.18%</span> de los <span className="font-semibold">desechos plásticos</span> encontrados en playas como{" "}
								<span className="text-cyan-600 font-bold">Los Palos, Tres Cruces, Caleta Vila Vila y Los Hornos</span>.
							</TextComponent>
						}
						imageSrc="https://wwflac.awsassets.panda.org/img/small_ww260730_690160.jpg"
						imageAlt="tortuga amarrada con una bolsa"
					/>
					<CardPlastic
						title="Botellas"
						description={
							<TextComponent
								variant="h5"
								className="text-center"
							>
								Las personas que beben de <span className="font-semibold text-yellow-600">botellas de plástico</span> son muy frecuentes en Tacna, y cuando estas llegan a ser{" "}
								<span className="font-semibold text-red-600">calentadas por el sol</span>, están expuestas a la{" "}
								<span className="font-semibold text-red-600">lixiviación química de BPA y ftalatos</span> que contaminan con sus químicos el agua, lo que se ha relacionado con{" "}
								<span className="font-semibold text-red-600">problemas de reproducción</span> en las especies marinas.
							</TextComponent>
						}
						imageSrc="https://img.freepik.com/fotos-premium/primer-plano-botella-basura-plastica-playa_650366-3184.jpg"
						imageAlt="botella de plastico en la arena"
					/>
					<CardPlastic
						title="Cigarrillos"
						description={
							<TextComponent
								variant="h5"
								className="text-center"
							>
								Las <span className="font-semibold text-yellow-600">colillas de cigarrillo</span> representan una gran parte de los residuos recogidos en las limpiezas de playas de
								Tacna y son tan <span className="font-semibold text-red-600">tóxicas</span> que una sola colilla por litro de agua del océano es{" "}
								<span className="font-bold text-red-600">letal para la vida marina</span>.
							</TextComponent>
						}
						imageSrc="https://portaluniversidad.org.ar/wp-content/uploads/2022/12/multimedia.normal.8e86e88aa65d0992.636f6c696c6c61732d706c617961735f6e6f726d616c2e77656270.webp"
						imageAlt="cigarrillos enterrados en la arena"
					/>
					<CardPlastic
						title="Microplásticos"
						description={
							<TextComponent
								variant="h5"
								className="text-center"
							>
								Las <span className="font-semibold text-yellow-600">microperlas, fragmentos de plástico y microfibras</span> están presentes en las playas y aguas de Tacna,
								acumulándose incluso en los <span className="font-semibold text-cyan-600">peces locales</span>. Esto provoca que los{" "}
								<span className="font-semibold text-red-600">químicos plásticos tóxicos</span> ingresen a la <span className="font-semibold">cadena alimentaria</span>, afectando al{" "}
								<span className="font-bold text-green-600">pescado que se consume en la zona</span>.
							</TextComponent>
						}
						imageSrc="https://pensemosverde.com/wp-content/uploads/2020/06/imagen1-7.jpg"
						imageAlt="pescado con plastico adentro"
					/>
				</Row>
			</Column>
			<Column className="grid grid-cols-1 md:grid-cols-2 sm:w-[40rem] md:w-[50rem] xl:w-[60rem] gap-5 self-center py-10 max-md:px-5">
				<img
					className="rounded-lg"
					src="https://scontent.ftcq2-1.fna.fbcdn.net/v/t1.6435-9/72574824_2772250929475138_2515702202287259648_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeEop0oB-kP95U50Fbg4wnhUFrgY7x5Nh4wWuBjvHk2HjCgTOKd_H6BBIDTiEgVISroa_nObOZnUaSr7LoUIIwHw&_nc_ohc=zupL3MloHSIQ7kNvwEqLxo8&_nc_oc=Adl5GLB-vAy3bM3It67aCV1EDHqr68RqqJruFafmZ8ZK6AxJXwFltk2TXwTF94nVewc&_nc_zt=23&_nc_ht=scontent.ftcq2-1.fna&_nc_gid=uZYUHxDmZOdiYW5JB4ZrWQ&oh=00_AfLQoDuiHZfD1fEyVqGl41llp8jveygTnT4IbB7qzNE-1Q&oe=684F086C"
					alt="triptico de como cuidar el mar"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<img
					className="rounded-lg"
					src="https://img.freepik.com/vector-gratis/ilustracion-contaminacion-plastica-oceano-dibujado-mano_52683-114844.jpg"
					alt="triptico de como cuidar el mar"
					data-sal="slide-left"
					data-sal-duration="1000"
				/>
			</Column>
		</>
	);
};
